import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
window.onbeforeunload = function () {
  localStorage.removeItem("curPage");
  localStorage.removeItem("typeName");
};
ReactDOM.render(<App />, document.getElementById("root"));
